import React, { useEffect, useState } from 'react'
import { Alert } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { ApplicationState } from 'src/store'
import { getIssuances } from 'src/core/store/ducks/issuances/actions'
import { PageHeader } from 'src/components/Ant'
import history from 'src/config/routes/history'
import RequestNumberFilter from 'src/views/Requests/components/request-number-filter'
import RequestTitleFilter from 'src/views/Requests/components/request-title-filter'
import StatusFilter from 'src/views/Requests/components/StatusFilter'
import useDocumentTitle from 'src/hooks/use-document-title'
import * as CSS from './styles'
import RequestOrganizationFilter from './components/organization-filter'
import Table, { DataSource } from './components/table'

function Issuances() {
  const dispatch = useDispatch()
  const { issuances } = useSelector((state: ApplicationState) => ({
    issuances: state.issuances
  }))
  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  useDocumentTitle('web.side.my-requests')
  useEffect(() => {
    dispatch(getIssuances())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      issuances.list.map(
        ({
          request_agency_id,
          request_id,
          request_agency_number,
          organization_id,
          request: {
            request_number,
            title,
            requested_on,
            request_user_data = [],
            organization_name
          },
          status
        }) => ({
          id: request_agency_id,
          request_id,
          organization_id,
          number: request_agency_number,
          request_number,
          organization: organization_name,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          users: request_user_data.map(
            ({ status, traveler: { gender, name, user_id } }) => ({
              gender,
              name,
              status,
              user_id
            })
          ),
          title
        })
      )
    )
  }, [issuances.list])

  return (
    <>
      <PageHeader title="web.agencies.issuances.title" />
      {issuances.error && (
        <Alert message={issuances.error} showIcon type="error" />
      )}
      <CSS.HeaderFilters>
        <RequestOrganizationFilter
          items={issuances.organizations}
          loading={issuances.loading}
          onChange={values => {
            const { customer_tenant_id, customer_organization_id } = values
            dispatch(
              getIssuances({
                filterOrganizationsId: customer_organization_id,
                filterTenantId: customer_tenant_id,
                page: 1
              })
            )
            setCurrentPage(1)
          }}
        />
        <RequestNumberFilter
          initialValues={issuances.filterRequestNumber}
          onChange={values => {
            dispatch(getIssuances({ request_numbers: values, page: 1 }))
            setCurrentPage(1)
          }}
        />
        <RequestTitleFilter
          initialValues={issuances.filterRequestTitle}
          onChange={values => {
            dispatch(getIssuances({ request_title: values, page: 1 }))
            setCurrentPage(1)
          }}
        />
        <StatusFilter
          defaultValue={issuances.filterStatus}
          onChange={values => {
            dispatch(getIssuances({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={[
            'quotation_pending',
            'emission_pending',
            'quotation_reproved',
            'emission_reproved',
            'finished',
            'canceled'
          ]}
          style={{ margin: '16px 8px', minWidth: 200 }}
        />
      </CSS.HeaderFilters>
      <Table
        currentPage={currentPage}
        dataSource={list}
        loading={issuances.loading}
        onChange={page => {
          dispatch(getIssuances({ page }))
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => {
          return {
            onClick: () =>
              history.push(
                `/agencies/issuances/${record.id}/${record.request_id}/${record.organization_id}/summary`
              )
          }
        }}
        totalPages={issuances.total_results}
      />
    </>
  )
}

export default Issuances
